import { Input } from 'antd';
import React from 'react';

import { CloseOutlined, SearchOutlined } from '@ant-design/icons';

export interface ISearchInput {
  onClose: () => void;
  text: string;
  onChange: (value: string) => void;
}

export const SearchInput: React.FC<ISearchInput> = (props) => {
  const { onClose, text, onChange } = props;
  return (
    <>
      <SearchOutlined />
      <Input
        size="small"
        placeholder="Search..."
        style={{ margin: '0 6px' }}
        value={text}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
      />
      <CloseOutlined onClick={onClose} />
    </>
  );
};
